export default "__VITE_ASSET__C5FIiE_Q__"